export default {
    data,
};

function data(){
    return {
        modalOpen: true
    };
}
